/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Region_Micro_CountriesInputs */

const bn_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাইক্রো দেশ`)
};

const de_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikroländer`)
};

const el_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μικρές χώρες`)
};

const en_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micro countries`)
};

const es_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micropaíses`)
};

const fr_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micro-pays`)
};

const hi_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूक्ष्म देश`)
};

const hu_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikro országok`)
};

const id_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negara-negara mikro`)
};

const it_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micropaesi`)
};

const ja_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミクロ諸国`)
};

const ko_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마이크로 국가`)
};

const nl_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micro-landen`)
};

const pl_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraje mikro`)
};

const pt_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micropaíses`)
};

const ru_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Микространы`)
};

const sv_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikroländer`)
};

const tr_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mikro ülkeler`)
};

const uk_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мікро країни`)
};

const vi_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các nước vi mô`)
};

const zh_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`微观国家`)
};

const zh_hant_region_micro_countries = /** @type {(inputs: Region_Micro_CountriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`微觀國家`)
};

/**
* | output |
* | --- |
* | "Micro countries" |
*
* @param {Region_Micro_CountriesInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const region_micro_countries = /** @type {((inputs?: Region_Micro_CountriesInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Region_Micro_CountriesInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_region_micro_countries(inputs)
	if (locale === "de") return de_region_micro_countries(inputs)
	if (locale === "el") return el_region_micro_countries(inputs)
	if (locale === "en") return en_region_micro_countries(inputs)
	if (locale === "es") return es_region_micro_countries(inputs)
	if (locale === "fr") return fr_region_micro_countries(inputs)
	if (locale === "hi") return hi_region_micro_countries(inputs)
	if (locale === "hu") return hu_region_micro_countries(inputs)
	if (locale === "id") return id_region_micro_countries(inputs)
	if (locale === "it") return it_region_micro_countries(inputs)
	if (locale === "ja") return ja_region_micro_countries(inputs)
	if (locale === "ko") return ko_region_micro_countries(inputs)
	if (locale === "nl") return nl_region_micro_countries(inputs)
	if (locale === "pl") return pl_region_micro_countries(inputs)
	if (locale === "pt") return pt_region_micro_countries(inputs)
	if (locale === "ru") return ru_region_micro_countries(inputs)
	if (locale === "sv") return sv_region_micro_countries(inputs)
	if (locale === "tr") return tr_region_micro_countries(inputs)
	if (locale === "uk") return uk_region_micro_countries(inputs)
	if (locale === "vi") return vi_region_micro_countries(inputs)
	if (locale === "zh") return zh_region_micro_countries(inputs)
	return zh_hant_region_micro_countries(inputs)
});